// NOTE: 記事関連画像のS3を参照する
export const IMAGEFLUX_BASE_URL_MAP = {
  production: 'https://p2-f82ad187.imageflux.jp',
  staging: 'https://p2-c31a028b.imageflux.jp',
  local: 'http://kiwi-stub.localhost:8089/__mock_image_flux__',
};

// NOTE: レシピ関連画像のS3を参照する
export const RECIPE_IMAGEFLUX_BASE_URL_MAP = {
  production: 'https://p1-c111580b.imageflux.jp',
  staging: 'https://p1-b891a031.imageflux.jp',
  local: 'http://kiwi-stub.localhost:8089/__mock_image_flux__',
};
